import React, { useState, useContext, useEffect } from 'react';
import { Container, Jumbotron, Tabs, Tab, Alert, Row, Col, FormGroup, FormControl, Form } from 'react-bootstrap';
import { useHistory, useLocation } from 'react-router-dom';
import { PrivacyPolicy, TermsOfService, MITLicense } from 'react-quick-legal';

import Card from '@material-ui/core/Card';
import { Logger } from 'aws-amplify';
import Screens from '..';
import { alertsStore } from '../../contexts';
import { Button } from 'react-bootstrap';
import LogoBasic from '../../assets/images/basicLogo.svg';
const companyName = 'Neurotargeting LLC';
const privacyPolicyLink = 'https://legal.cranial.cloud/privacy';
const Home = (props) => {
	const location = useLocation();
	const history = useHistory();
	const { stateAlert, dispatchAlert } = useContext(alertsStore);
	const [ data, setData ] = useState(null);

	const onDiscardAlert = (alert) => {
		dispatchAlert({ type: 'discard', payload: alert });
	};

	useEffect(() => {
		dispatchAlert({
			type: 'add',
			payload: { type: 'info', msg: 'Add alerts through dispatchAlerts(type:"add",...' }
		});
	}, []);

	return (
		<Container
			fluid
			className="login-container"
			style={{ position: 'relative', overflow: 'hidden', display: 'flex', justifyContent: 'center' }}
		>
			<Row className="align-items-center" style={{ width: '100%' }}>
				<Col md={12}>
					<img id="login-logo-sm" src={LogoBasic} />
					<p id="upstream">upstream </p>

					<Card className="mb-2 dashboard-card  dashboard-card-title" style={{ width: '100%' }}>
						<div>
							<h1>Terms of Service</h1>
							<div>
								<TermsOfService
									companyName={companyName}
									privacyPolicyLink={privacyPolicyLink}
									agreeToDisclaimer={true}
								/>
							</div>
						</div>
					</Card>
				</Col>
			</Row>
		</Container>
	);
};

export default Home;
